export default "__VITE_ASSET__DAfUJzOr__"